import { Component, input, signal } from "@angular/core";
import { MenuItem } from "../menu/menu.component";


@Component({
    selector: 'app-menu-item',
    templateUrl: './menu-item.component.html',
    styleUrls: ['./menu-item.component.scss'],
    standalone: false
})
export class MenuItemComponent {

  item = input.required<MenuItem>();
  collapsed = input(false);
  nestedMenuOpen = signal(false);


  toggleNested(): void {
    this.nestedMenuOpen.set(!this.nestedMenuOpen());
  }

  isExternalLink(route?: string): boolean {
    return route?.startsWith('http');
  }



}
